import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Get token from localStorage
  const token = localStorage.getItem('auth_token');

  // Admin API uses its own token (admin_token); skip adding user token for /admin
  if (req.url.includes('/admin')) return next(req);
  // If token exists and this is not the login/register endpoint, add Authorization header
  if (token && !req.url.includes('/auth/login') && !req.url.includes('/auth/register')) {
    const clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    // Process the request and extract refreshed token from response headers
    return next(clonedRequest).pipe(
      tap(event => {
        // Check if response has headers (HttpResponse)
        if (event.type === 4) { // HttpEventType.Response
          const response = event as any;
          const refreshedToken = response.headers?.get('X-Auth-Token');

          // If backend sent a refreshed token, update localStorage
          if (refreshedToken) {
            localStorage.setItem('auth_token', refreshedToken);
          }
        }
      })
    );
  }

  return next(req);
};

